const searchType = Object.freeze({
    SIA: "SIA",
    Credits: "Credit Check",
    RightToWork: "Right To Work",
    FinancialSanctions: "Financial Sanctions",
    socialMediaChecks: "socialMediaChecks",
});

export default searchType;